<template>
    <footer class="page-layout__footer  page-footer  page-footer--dark"
            :class="{'footer--space-for-sidebar':$store.getters['candidate/getCurrentTesting'] && $store.getters['candidate/getCurrentTesting'].questionSettings && $store.getters['candidate/getCurrentTesting'].questionSettings.optionValue===QUESTION_SETTINGS_ALL}">
        
        <div class="page-footer__copyright">
            Разработчик: <a href="https://infocom.kg/">Государственное предприятие «Инфоком»</a> <br>
            © Зарегистрирован в Государственном реестре программ для ЭВМ Кыргызской Республики от 26.09.2018 года, сертификат за № 525
        </div>
    
    </footer>
</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style scoped>
    .footer--space-for-sidebar {
        margin-left: 190px !important;
    }
</style>
